import { createFileRoute, redirect } from '@tanstack/react-router';

// Root path bounces to /home; the protected guard there decides whether to
// land on /home or /login. Keeps a single source of truth for auth routing.
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/home' });
  },
});
